const invitees = {
  a001: { name: "Budi Santoso", greet: "Bapak Budi Santoso", invitee_from: "Fandi" },
  a002: { name: "Siti Nurhaliza", greet: "Ibu Siti Nurhaliza", invitee_from: "Mitha" },
  a003: { name: "Ahmad Rizki", greet: "Bapak Ahmad Rizki", invitee_from: "Fandi" },
  a004: { name: "Dewi Lestari", greet: "Ibu Dewi Lestari", invitee_from: "Mitha" },
  a005: { name: "Rina Amelia", greet: "Saudari Rina Amelia", invitee_from: "Fandi" },
  ab12: { name: "Seseorang", greet: "Seseorang", invitee_from: "Fandi" },
};

export default invitees;
